import { render, staticRenderFns } from "./xtDialog.vue?vue&type=template&id=04544b4c&scoped=true&"
import script from "./xtDialog.vue?vue&type=script&lang=js&"
export * from "./xtDialog.vue?vue&type=script&lang=js&"
import style0 from "./xtDialog.vue?vue&type=style&index=0&id=04544b4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04544b4c",
  null
  
)

export default component.exports